import React, { useState, useMemo } from 'react';

import styled from 'styled-components';

import { forceReloadProject } from '@hooks/API/Project/UseProject';

import { useBookingEvent } from '@components/EventDrawer/BookingEvent/BookingEventContext';
import ManageModelsAndDates from '@components/EventDrawer/EventDrawerUi/ManageModelsAndDates';
import { NwAddButton, NwButton } from '@components/Gui/NwButton';
import NwDrawer from '@components/Gui/NwDrawer';

import AddModelsToBookingEvent from '../BookingEvent/AddModels/AddModelsToBookingEvent';
import { byPrefixAndName } from '@awesome.me/kit-d6dae216cd/icons';

export const EventDaysHeaderContainer = styled.div`
    position: ${(props) => !props.plainMode && 'sticky'};
    display: flex;
    justify-content: space-between;
    gap: 0.25rem;
    padding: 0px 1rem 0px 2rem;
    top: 150px;
    background: white;
    z-index: 2;
    align-items: center;
    box-shadow: 0px 2px 12px -8px rgb(0 0 0 / 40%);
    height: 50px;
    border-bottom: ${(props) => props.theme.DefaultBorder};

    @media (max-width: 720px) {
        padding: 0 1rem 0 1rem;
        width: 100%;
        top: 50px;
    }
`;

const EventDaysHeader = ({ plainMode, eventData, onAddDays, onEventPlanner, afterUpdate }) => {
    //onAddModels

    const [isManageModels, setIsManageModels] = useState(false);
    const [showAddModelDrawer, setShowAddModelDrawer] = useState(false);

    const { isMobile, breakpoint } = useBookingEvent();

    const handleManageModels = () => {
        setIsManageModels(true);
    };

    // const eventDatesModels = useMemo(() => {
    //     let eventDatesModels = [];
    //     for (const eventDate of eventData.EventDates) {
    //         eventDatesModels = [...eventDatesModels, ...eventDate.EventDatesModels];
    //     }
    //     return eventDatesModels;
    // }, [eventData]);

    const handleCloseAdd = () => {
        if (eventData.Project && eventData.Project.ID) {
            forceReloadProject(eventData.Project.ID);
        }
        setShowAddModelDrawer(false);
    };

    return (
        <EventDaysHeaderContainer plainMode={plainMode}>
            {!isMobile && (
                <NwButton
                    ghost
                    size="small"
                    icon={byPrefixAndName.fasl['stream']}
                    label="event planner"
                    onClick={onEventPlanner}
                />
            )}
            {(eventData.EventDates.length > 1 || eventData.NumModels > 1) && (
                <NwButton
                    ghost
                    size="small"
                    icon={byPrefixAndName.fasl['people-group']}
                    label={isMobile ? 'Models&Dates' : 'Models & Dates'}
                    onClick={handleManageModels}
                />
            )}
            <NwAddButton size="small" ghost onClick={onAddDays} label={isMobile ? 'days' : 'add days'} />
            <NwAddButton
                size="small"
                ghost
                onClick={() => setShowAddModelDrawer(true)}
                label={isMobile ? 'models' : 'add models'}
            />
            {isManageModels && (
                <NwDrawer
                    width="60rem"
                    padding="0px"
                    onClose={() => setIsManageModels(false)}
                    title="Manage models and dates"
                >
                    <ManageModelsAndDates
                        // eventDatesModels={eventDatesModels}
                        eventData={eventData}
                        afterUpdate={afterUpdate}
                    />
                </NwDrawer>
            )}
            {showAddModelDrawer && (
                <AddModelsToBookingEvent
                    event={eventData}
                    projectId={eventData.Project && eventData.Project.ID}
                    onClose={handleCloseAdd}
                />
            )}
        </EventDaysHeaderContainer>
    );
};

export default EventDaysHeader;
